/** @type {import('../help-index.js').HelpSidebarItem} */
export const ACC_JOU_GENERATE_ITEM = {
  id: 'generate_entries',
  screenId: 'acc-jou-generate',
  label: 'Generar',
  description: 'Asientos automáticos desde ventas, compras, cobros y pagos.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'El sistema crea asientos contables a partir de comprobantes ya cargados, según el plan de cuentas y los mapeos configurados.',
      },
      {
        title: 'Módulos',
        bullets: [
          'Ventas — facturas fiscales de venta.',
          'Compras — facturas de compra (fecha contable).',
          'Cobros — recibos de cobro por instrumento.',
          'Pagos — recibos de pago por instrumento.',
        ],
      },
      {
        title: 'Paso 1 — Parámetros',
        fields: [
          { label: 'Desde / Hasta', description: 'Rango de fechas del origen.' },
          {
            label: 'Nivel de detalle',
            description: 'Detallado (un asiento por comprobante), resumen diario o resumen mensual.',
          },
          { label: 'Simulación (dry run)', description: 'Vista previa sin grabar asientos.' },
        ],
      },
      {
        title: 'Paso 2 — Ejecutar',
        paragraphs: [
          'Tocá generar en el panel del módulo. Revisá la vista previa o el historial de corridas abajo.',
          'Requiere período contable abierto y cuentas/mapeos completos.',
        ],
      },
    ],
  },
}
